import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronRight, faHouse } from "@fortawesome/free-solid-svg-icons";
import { breadcrumbOf, nameOf } from "@serie3/mymediaplanner/Modules/Documents/Domain/folderTree";

/**
 * "My files › Kampagnen › 2026" above the file grid; every crumb is clickable.
 * `rootLabel` / `rootIcon` name the location (own files or a group's folder).
 */
const FolderBreadcrumb = ({ current = null, onSelect, rootLabel = null, rootIcon = faHouse }) => {
  const { t } = useTranslation();
  const crumbs = breadcrumbOf(current);

  return (
    <nav aria-label="folder path" style={{ display: "flex", alignItems: "center", flexWrap: "wrap", gap: 6, fontSize: 13, marginBottom: 14 }}>
      {crumbs.map((path, index) => {
        const last = index === crumbs.length - 1;
        return (
          <span key={path ?? "root"} style={{ display: "flex", alignItems: "center", gap: 6 }}>
            {index > 0 && <FontAwesomeIcon icon={faChevronRight} style={{ fontSize: 9, color: "#c1c6d0" }} />}
            <button
              type="button"
              onClick={() => onSelect(path)}
              disabled={last}
              style={{
                border: "none",
                background: "transparent",
                padding: "2px 4px",
                color: last ? "#111827" : "#038edc",
                fontWeight: last ? 600 : 500,
                cursor: last ? "default" : "pointer",
                fontFamily: "inherit",
                fontSize: 13,
              }}
            >
              {path === null ? (
                <>
                  <FontAwesomeIcon icon={rootIcon} style={{ marginRight: 5, fontSize: 11 }} />
                  {rootLabel ?? t("Backend.Files.Locations.Mine", { defaultValue: "My files" })}
                </>
              ) : (
                nameOf(path)
              )}
            </button>
          </span>
        );
      })}
    </nav>
  );
};

export default FolderBreadcrumb;
